import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class AffiliateService {

  constructor(private dataService: DataService) {}

  getAll(): Observable<any> {
    return this.dataService.get('affiliate');
  }

  getById(id: number): Observable<any> {
    return this.dataService.get(`affiliate/${id}`);
  }

  saveAffiliate(affiliate: FormData, message?: string) {
    return this.dataService.post('affiliate', affiliate, message);
  }

  updateAffiliates(affiliates: any, message?: string) {
    return this.dataService.put('affiliate', affiliates, message);
  }

  deleteAffiliate(id: number, message?: string) {
    return this.dataService.delete(`affiliate/${id}`, message);
  }
}
